<template>
    <router-view />
</template>

<style lang="scss">
@import "~primeflex/primeflex.css";
</style>